import { createApiWithNoBasePath as api } from "@api";

export const generateStripeAccountLink = async (serviceProviderId: number): Promise<string> => {
  const csrfToken =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content ?? "";

  const response = await api.post(
    "/api/stripe_account_links",
    { id: serviceProviderId },
    { headers: { "x-csrf-token": csrfToken } }
  );

  return (response.data as { url: string }).url;
};
